import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type NotificationCategory = 'primary' | 'link' | 'info' | 'success' | 'warning' | 'danger';

export interface NotificationConfig {
  text: string;
  category?: NotificationCategory;
  timeout?: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  onShow: Subject<NotificationConfig> = new Subject();
  constructor() { }

  show(text: string, category?: NotificationCategory, timeout?: number) {
    this.onShow.next({text, category, timeout});
  }
}
